import axios, { Method } from 'axios';
import { rootStore } from 'stores/index';

// import { errorToast } from 'components/Toast'

const baseUrl = process.env.REACT_APP_API_URL;
export const SOURCE_STR = process.env.REACT_APP_API_SRC;

export const appConst = {
  apiMockTimeout: 1000 * 10 // 10 seconds
};

const codes = {
  UNAUTHORIZED: 401,
  UNAUTHORIZED_MSG: 'Unauthorized User',
  CUSTOM_TOKEN_EXPIRED: -2,
  REQUEST_TIMEOUT: 408,
  ECONNABORTED: 'ECONNABORTED'
};

axios.interceptors.response.use(
  response => response,
  error => {
    const response = error?.response
    if (response) {
      if (response.status === codes.UNAUTHORIZED && response.data.error === codes.UNAUTHORIZED_MSG) {
        console.log('token expired');
        rootStore.AuthStore.onLogOut();
      }

      if (response.status === codes.REQUEST_TIMEOUT || error.code === codes.ECONNABORTED)
        console.log(`A timeout happend on url ${error.config.url}`);

      if (response.data?.error)
        console.log('Check server error.')
    }

    return Promise.reject(error);
  }
);

export const getFullUrl = (url: string) => {
  return `${baseUrl}${url}`;
};

export type Irequest = {
  subUrl: string;
  method?: Method;
  data?: object;
  params?: object;
  headers?: object;
};

export const get = (request: Irequest) => {
  return commonFetch({ method: 'get', ...request });
};

export const post = (request: Irequest) => {
  return commonFetch({ method: 'post', ...request });
};

export const patch = (request: Irequest) => {
  return commonFetch({ method: 'patch', ...request });
};

export const put = (request: Irequest) => {
  return commonFetch({ method: 'put', ...request });
};

export const deletee = (request: Irequest) => {
  return commonFetch({ method: 'delete', ...request });
};

const commonFetch = (request: Irequest) => {
  const { subUrl, method, data = {}, params, headers = {} } = request;
  const url = getFullUrl(subUrl);
  const commonHeaders = getCommonHeaders();
  return axios({
    method,
    url,
    params,
    data,
    headers: { ...commonHeaders, ...headers }
  });
};

export const content_types = {
  multipart: {
    'Content-Type': 'multipart/form-data'
  },
  json: {
    'Content-Type': 'application/json'
  }
};

const getCommonHeaders = () => {
  const {
    AuthStore: {
      state: {
        data: { token }
      }
    }
  } = rootStore;

  return {
    ...content_types.json,
    Authorization: `Bearer ${token}`,
    source: SOURCE_STR
  };
};

export type IconvertToFormProp = {
  [key: string]: string | Blob | undefined | boolean;
};

export const convertToForm = (item: IconvertToFormProp) => {
  const form_data = new FormData();
  for (const key in item) {
    const value = item[key];
    if (value) {
      form_data.append(
        key,
        typeof value === 'boolean' ? value.toString() : value
      );
    }
  }
  return form_data;
};
